module.exports = __webpack_public_path__ + "static/media/233.408228f6.wav";